import { ThemeInfo } from '../types';

export const DEFAULT_LIGHT_THEME: ThemeInfo = {
  styles: {
    '--gl-background': '#ffffff',
    '--gl-foreground': '#000000',
  },
};
